import React, { useState } from 'react';
import "../css/chat-rating.css";
import {
  Box,
  Button,
  Rating,
  TextField,
  Typography,
} from '@mui/material';
// import Rating from '@mui/material/Rating';
// import { Button } from '@mui/material/Button';
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
// import Typography from '@mui/material/Typography';

export default function ChatRating(props) {
  const { handleSetRating } = props
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [isRated, setIsRated] = useState(false);
  const getRatingHeader = () => {
    return `Please rate for the conversation`
  }

  const handleSumbitRatingAndComment = async () => {
    const result = await handleSetRating({rating, comment} || 0);
    console.log(`result: ${JSON.stringify(result)}`);
    setIsRated(true)
  };    

  return (
    <Box className='chat-rating-container'>
      <Typography component="legend">{getRatingHeader()}</Typography>
      <Box className='chat-rating-input-fields-container'>
        <Box className='chat-rating-input-fields'>
          <Rating
            className='chat-rating'
            rating={rating}
            getLabelText={(rating) => `${rating} Rating${rating !== 1 ? 's' : ''}`}
            icon={<StarRateRoundedIcon fontSize="inherit" />}
            emptyIcon={<StarBorderRoundedIcon fontSize="inherit" />}
            // onChange={(_event, newValue) => handleRatingClick(newValue)}
            onChange={(_event, newValue) => setRating(newValue || 0)}
            readOnly={isRated}
          />
          <TextField
            className='chat-comment'
            id="comment" 
            label="Comment"
            variant="standard" 
            value={comment}
            onChange={(event) => { setComment(event.target.value) }}        
            InputProps={{ readOnly: isRated }}
          />
        </Box>
      </Box>
      {
       !isRated &&
        <Button
          className='chat-rating-submit-button'
          variant="outlined"
          size="small"
          onClick={() => { handleSumbitRatingAndComment() }}
          disabled={isRated}
        >
          Submit
        </Button> 
      }
      
      {isRated && <Typography component="legend">Thank you for rating the conversation</Typography>}
    </Box>
  );
}
